import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Stroj smo mi",
  "description": "",
  "published": "2007-04-11T00:00:00.000Z",
  "redirect_from": ["/blog/stroj-smo-mi/swizec/234"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`ÄŒe te tole ne pripravi do globokega razmišljanja, si budala brez sposobnosti Äloveških miselnih procesov in popolno asimiliran. Sedaj konÄno vidim internet v svoji pravi podobi, je Borg.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      